import { useMemo, useState, type CSSProperties, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

export default function ChartFullscreenWrapper({ children, style }: Props) {
  const [isZoomed, setIsZoomed] = useState(false);
  const [isScaling, setIsScaling] = useState(false);

  const setZoom = (zoomed: boolean) => {
    setIsScaling(true);
    setTimeout(() => {
      setIsZoomed(zoomed);
      setIsScaling(false);
    }, 250);
  };

  const classNames = useMemo(() => {
    const classes = ["chart-wrapper"];
    if (isScaling) {
      classes.push("scale");
    }
    if (isZoomed) {
      classes.push("zoomed-chart");
    }
    return classes.join(" ");
  }, [isScaling, isZoomed]);

  return (
    <div>
      {isZoomed ? <div className="chart-overlay" onClick={() => setZoom(false)} /> : null}
      <div className={classNames} style={style}>
        <a
          href="#"
          className="big-edit zoom-in-chart"
          onClick={(event) => {
            event.preventDefault();
            setZoom(!isZoomed);
          }}
        >
          <i className="material-icons">{isZoomed ? "clear" : "zoom_out_map"}</i>
        </a>
        {children}
      </div>
    </div>
  );
}
